export default {
  GET_RB_PAGE: (state, data) => {
    state.rencanaBelanjaPage = data;
  },
  GET_TOTAL_DATA: (state, data) => {
    state.total = data;
  },
};
